// extracted by mini-css-extract-plugin
module.exports = {"container":"dE","title":"dF","tabs":"dG","text":"dH","textForm":"dI","submitButton":"dJ","checkboxContainer":"dK","errorMessage":"dL"};